import {TokenCredentials} from '../login/tokencredentials';

export class Article {
    credentials: TokenCredentials;

    constructor() {
        this.units = [];
        this.descr = [];
        this.descr.push(new ArticleDescr());
        this.descr[0].langCode = 'def';
        this.weight = 0;
    }

    id : number;
    userId: number;
    clientId: number;
    articleNumber: string;
    baseUnitId: number;
    weight: number;
    serialNumber: string;
    charge: string;
    pickable: string;

    units : ArticleUnit[];
    descr : ArticleDescr[];
}

export class ArticleUnit {
    id :number;
    unit: string;
    type: string;
    baseFactor: number;
}

export class ArticleDescr {
    langCode: string;
    name1: string;
    name2: string;
    name3: string;
    name4: string;
    descr: string;
}

export class ArticleListElement {
    id : number;
    articleNumber: string;
    name1: string;
    name2: string;
    weight: number;
    baseUnit: string;
    serialNumber: string;
    charge: string;
    pickable: string;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/article/article.ts